module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-chalk-1-adfef03f38cae6b751aa83c183913474.png";